import React, { useCallback, useMemo, useRef, useState } from 'react';
import bem from 'utils/bem.js';
import { JazzRoom } from '@salutejs/jazz-sdk-web';
import { useMobile } from 'utils/media.js';
import { useQuery } from '../../utils/hooks/useQuery';
import { useParticipantMediaMuted } from '../../utils/hooks/useParticipantMediaMuted';
import { RequestPermissionVideo } from './RequestPermissionVideo';
import { RequestPermissionAudio } from './RequestPermissionAudio';
import { LeaveRoomButton } from './LeaveRoomButton';
import { useRoomContext } from '../../contexts/RoomContext';
import { FullscreenButton } from './FullscreenButton';
import { Sidebar } from '../../components/Sidebar';
import { MediaSettings } from '../MediaSettings';
import { SettingsButton } from './SettingsButton';
import { SwitchCameraButton } from './SwitchCameraButton';
import './index.sass';
import { BluetoothAudioButton } from './BluetoothAudioButton';
import { MediaDevicePopover } from '../../components/MediaDevicePopover';

const { block, el } = bem('room-actions');

export const RoomActions = ({ isFullscreen, toggleFullscreen, container }) => {
    const anchorRef = useRef(null);
    const [openMediaSettings, setOpenMediaSettings] = useState(false);
    const toggleMediaSettings = useCallback(() => {
        setOpenMediaSettings((openMediaSettings) => !openMediaSettings);
    }, []);
    const closeMediaSettings = useCallback(() => {
        setOpenMediaSettings(false);
    }, []);

    const { room } = useRoomContext();
    const localParticipant = useQuery(room.localParticipant);
    const { isAudioMuted, isVideoMuted } = useParticipantMediaMuted(room as JazzRoom, localParticipant);

    return (
        <div className={ block() }>
            <div className={ el('bottom') }>
                <RequestPermissionAudio isAudioMuted={ isAudioMuted } />
                <RequestPermissionVideo isVideoMuted={ isVideoMuted } />
                <LeaveRoomButton />
            </div>
            <div className={ el('top') } ref={anchorRef}>
                <FullscreenButton isFullscreen={ isFullscreen } toggleFullscreen={ toggleFullscreen } />
                <BluetoothAudioButton />
                <SettingsButton onClick={ toggleMediaSettings } active={ openMediaSettings } />
            </div>
            <MediaDevicePopover open={ openMediaSettings } handleClose={ closeMediaSettings } anchorEl={anchorRef.current} container={container}>
                <MediaSettings />
            </MediaDevicePopover>
            {/*<Sidebar open={ openMediaSettings } setOpen={ setOpenMediaSettings }>*/}
            {/*    <MediaSettings />*/}
            {/*</Sidebar>*/}
        </div>
    );
};
